export default __webpack_public_path__ + "static/media/v8-ignition.fe30e7b2.svg";